/** Provides constants for node edge attributes.*/
export const EDGE = {
	SOURCE: "source",
	TARGET: "target",
	ID: "id",
	PROPERTY: "p",
	PROPERTY_LABEL: "pl",
	GRAPH: "g",
	AXIOM: "ax",
};
